var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSigned = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 34,
  fill: "none",
  stroke: "current",
  strokeWidth: 3,
  viewBox: "0 0 64 64"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "M49.89 7.74V43.4L37.94 56.26H12.28V7.74z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m37.92 56.26.02-12.86h11.95M17.58 45.36h15.01M17.58 38.84h24.01M17.58 32.74h27.01M24.06 20.81l4.57 3.45 8.07-11.33"
})));
export { SvgSigned as ReactComponent };
export default __webpack_public_path__ + "af5265f019c77f2942ecdf85afb9f6d8.svg";